import React from "react";
import Select from "react-select";

const BrandRestrictor = ({
  brands,
  restrictedBrands,
  setRestrictedBrands,
  brandsLoading,
  selectedCategory,
  setCategoryBrandRestrictions,
}) => {
  const brandOptions = brands?.filter(
    (brand) =>
      !restrictedBrands?.some(
        (restrictedBrand) => restrictedBrand.brand === brand.value
      )
  );
  return (
    <div className="mb-2">
      <p className="mb-1 text-[13.6px] text-brand-grey-700">Hidden Brands</p>
      <p className="text-[12.8px] text-[#aaaaaa] mb-2 font-[300]">
        Hides brands for the selected category
      </p>
      <Select
        isMulti
        name="brands"
        options={brandOptions}
        className="basic-multi-select"
        classNamePrefix="select"
        isLoading={brandsLoading}
        isDisabled={brandsLoading || !selectedCategory?.value}
        value={restrictedBrands}
        onChange={(e) => {
          setRestrictedBrands(e || []);
          setCategoryBrandRestrictions((prev) => {
            if (e === null || e?.length === 0) {
              return prev?.filter(
                (currentRestrictedBrand) =>
                  currentRestrictedBrand?.category !== selectedCategory?.value
              );
            } else {
              return [
                ...prev?.filter(
                  (currentRestrictedBrand) =>
                    currentRestrictedBrand?.category !== selectedCategory?.value
                ),
                ...e?.map((brand) => ({
                  brand: brand.value,
                  category: selectedCategory?.value,
                })),
              ];
            }
          });
        }}
        placeholder="Select brands to hide"
      />
    </div>
  );
};

export default BrandRestrictor;
